import React from 'react';
export default {
  'cart': {
    'change-currency': 'Ändra valuta',
    'and-then': 'Och sedan',
    'plus-tax': ' + skatt',
    'for': 'För',
    'edit': {
      'label': 'Redigera',
      'submit': 'Tillämpa'
    },
    'empty': 'Du har inte lagt till något i din beställning än.',
    'free': 'gratis',
    'promo-code': {
      'add': 'Lägg till presentkort eller kampanjkod',
      'error': {
        'invalid-for-subscription': 'Kupongkoden är inte giltig för denna beställning.'
      },
      'label': 'Presentkort eller kampanjkod',
      'submit': 'Tillämpa'
    },
    'subtotal-line': {
      'tax-label': 'Uppskattad skatt',
      'subtotal': 'Delsumma',
      'tax': 'Skatt',
      'gift-card': 'Present kort'
    },
    'starting-price': 'Startpris',
    'title': 'Ordersammanfattning',
    'setup-fee': 'installationsavgift',
    'free-trial': 'Gratis provperiod',
    'total-line': {
      'label': 'Totalt'
    },
    'order-total-line': {
      'label': 'Order Summa'
    }
  },
  'address': {
    'country': 'Land',
    'address2': 'Lägenhet, svit, etc.',
    'tax-identifier': 'Skatteidentifiering',
    'tax-identifier-type': 'Typ av skatteidentifiering',
    'first-name': 'Förnamn',
    'last-name': 'Efternamn',
    'company-name': 'Företagsnamn',
    'address1': 'Gatuadress',
    'city': 'Stad',
    'state': 'Stat',
    'postal-code': 'Zip/Post',
    'phone-number': 'Telefonnummer',
    'vat-number': 'Momsregistreringsnummer/Skatte-ID'
  },
  'payment-method': {
    'credit-card': {
      'label': 'Kortuppgifter',
      'expiry': 'MM/ÅÅ',
      'name': 'Kreditkort',
      'number': 'Kortnummer',
      'cvv': 'CVV',
      'brand': {
        'visa': 'Visa',
        'master': 'MasterCard',
        'cartes_bancaires': 'Cartes Bancaires'
      }
    },
    'ach': {
      'name': 'Bankkonto',
      'routing-number': 'Clearingnummer',
      'account-number': 'Kontonummer',
      'account-number-confirmation': 'Bekräfta kontonummer',
      'account-type': {
        'label': 'Kontotyp',
        'checking': 'Kontroll',
        'savings': 'Besparingar'
      },
      'name-on-account': 'Namn på konto'
    },
    'amazon': {
      'name': 'Amazon Pay'
    },
    'apple-pay': {
      'name': 'Apple Pay'
    },
    'boleto': {
      'name': 'Boleto'
    },
    'bacs': {
      'name': 'Bacs',
      'sort-code': 'Sort kod'
    },
    'becs': {
      'name': 'BECS',
      'bsb-code': 'BSB-kod'
    },
    'google-pay': {
      'name': 'Google Pay'
    },
    'ideal': {
      'name': 'Ideal'
    },
    'paypal': {
      'name': 'PayPal'
    },
    'qiwi_wallet': {
      'name': 'Qiwi Wallet'
    },
    'sepa': {
      'name': 'SEPA',
      'iban': 'IBAN'
    },
    'sofort': {
      'name': 'Sofort'
    },
    'venmo': {
      'name': 'Venmo'
    }
  },
  'billing-address': 'Faktureringsadress',
  'billing-address-same-as-shipping': 'Samma som leveransadress',
  'submit': 'Betala nu',
  'payment-method-selected': ({ paymentMethod }: { paymentMethod: string }) => <>{paymentMethod} vald</>,
  'express-checkout': 'Expressutcheckning',
  'change-payment-method': 'Ändra betalmetod',
  'day': 'dag',
  'days': 'dagar',
  'week': 'vecka',
  'weeks': 'veckor',
  'month': 'månad',
  'months': 'månader',
  'year': 'år',
  'years': 'år',
  'confirmation': {
    'title': 'Tack för din beställning',
    'order-num': ({ number }: { number: number }) => <>Ordernummer {number}</>,
    'fulfilled-on': ({ date }: { date: string }) => <>Avslutad den {date}</>,
    'email-notice': 'Du kommer att få en e-postbekräftelse på din beställning.',
    'payment': 'Betalning',
    'return-to': ({ name }: { name: string }) => <>Återgå till {name}</>,
    'credit-applied': 'Kredit Tillämpad'
  },
  'back': 'Tillbaka',
  'contact-info': 'Kontaktinformation',
  'email-address': 'E-post',
  'payment-info': 'Faktureringsinformation',
  'shipping-address': 'Leveransadress',
  'legal': {
    'accept': 'Jag accepterar',
    'privacy-policy': 'Integritetspolicy',
    'terms-of-service': 'Användarvillkor'
  },
  'recurring': {
    'consent': `Jag samtycker till att betala avgifterna ovan som visas med en faktureringsfrekvens,
                på återkommande basis, såvida inte prenumerationen sägs upp före slutet av den aktuella faktureringsperioden.`,
    'cancel': 'För att säga upp din prenumeration, besök din sida Kontohantering.'
  },
  'pluralize': {
    'days': ({ count }: { count: number }) => count === 1 ? 'dag' : 'dagar',
    'weeks': ({ count }: { count: number }) => count === 1 ? 'vecka' : 'veckor',
    'months': ({ count }: { count: number }) => count === 1 ? 'månad' : 'månader',
    'years': ({ count }: { count: number }) => count === 1 ? 'år' : 'år'
  },
  'subscription': {
    'details': {
      'addons': {
        'flat.charge': ({ amount, addOnName }: { amount: string; addOnName: string }) => <>Du kommer att debiteras {amount}/enhet för {addOnName}</>,
        'no-flat.charge': ({ amount, units, unitsLabel, addOnName }: { amount: string; units: number; unitsLabel: string; addOnName: string }) => <>Du kommer att debiteras {amount} för {units} {unitsLabel} av {addOnName}</>
      },
      'billing.starting': ({ startDate, amount, intervalLengthLabel, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; taxable?: boolean }) => <>Från och med {startDate} kommer du att faktureras {amount}/{intervalLengthLabel}{taxable ? ' + skatt' : ''}</>,
      'billing.starting.setupfee': ({ startDate, amount, intervalLengthLabel, setupFee, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; setupFee: string; taxable?: boolean }) => <>Från och med {startDate} kommer du att faktureras {amount}/{intervalLengthLabel}{taxable ? ' + skatt' : ''}, tillsammans med en engångsavgift på {setupFee}</>,
      'cancellation.reminder': ({ days }: { days: number }) => `Du får en påminnelse via e-post ${days} dagar innan faktureringen börjar.`,
      'trial.start': ({ trialLength, trialInterval }: { trialLength: string; trialInterval: string }) => <>Din gratis {trialLength} {trialInterval} provperiod börjar idag.</>,
      'trial.ends': ({ trialEndsAt }: { trialEndsAt: string }) => <>För att undvika att debiteras måste du avbryta innan {trialEndsAt}.</>,
      'email.reminder': ({ days }: { days: number }) => <>Du får en påminnelse via e-post {days} dagar innan faktureringen börjar</>,
      'no-renewal': ({ billingEndsAt }: { billingEndsAt: string }) => <>Din prenumeration kommer att avslutas den {billingEndsAt} och förnyas inte automatiskt.</>,
      'ramp.after': ({ afterChargeTime, newChargeAmount }: { afterChargeTime: string; newChargeAmount: string }) => <>Efter {afterChargeTime} kommer du att debiteras {newChargeAmount} + skatt</>,
      'renewal': ({ totalCyclesLengthLabel }: { totalCyclesLengthLabel: string }) => <>Din prenumeration förnyas automatiskt varje {totalCyclesLengthLabel} och fortsätter tills du avbryter.</>,
      'title': 'Prenumerationsinformation',
    },
    'agreement.button': 'Godkänn och Fortsätt',
    'agreement.text': 'Genom att klicka på "Godkänn och Fortsätt" bekräftar du att du förstår och accepterar dessa prenumerationsvillkor. Inga avgifter tillkommer förrän du slutför köpet.',
    'changeOrCancel': 'För att ändra eller avbryta din prenumeration ',
    'access-account': 'komma åt ditt konto',
    'contact-support': 'kontakta support',
  },
  'currency-display': ({ currency }: { currency: string }) => <>{(currency || '').toUpperCase()}</>,
  'support': {
    'array': {
      'wordsConnector': ', ',
      'twoWordsConnector': ' och ',
      'lastWordConnector': ' och '
    }
  },
  'powered-by': ({ recurly }: { recurly: string }) => <>Prenumerationsfakturering drivs av {recurly}</>,
  'errors': {},
  'subscribe': 'Prenumerera'
};
